module.exports = __webpack_public_path__ + "img/hi-res-18.a0c457f7.jpg";